import Call from "../../service/axios";
import {getUrl} from "../../constants/urls";
import {trackPromise} from "react-promise-tracker";

export const getSims = (pageUrl) => {
  const simUrl = pageUrl ? pageUrl : getUrl("listSim");
  return trackPromise(Call.get(simUrl));
};

export const createSim = (payload) => {
  const simUrl = getUrl("listSim");
  return trackPromise(Call.post(simUrl, payload));
};

export const deleteSim = (id = "") => {
  const url = getUrl("listSim");
  const patchUrl = `${url}${id}/`;
  return trackPromise(Call.delete(patchUrl));
};

export const suspendSim = (id = "") => {
  const url = getUrl("simSuspend")(id);
  return trackPromise(Call.patch(url));
};

export const activateSim = (id = "") => {
  const url = getUrl("simActivate")(id);
  return trackPromise(Call.patch(url));
};

export const deactivateSim = (id = "") => {
  const url = getUrl("simDeactivate")(id);
  return trackPromise(Call.patch(url));
};
export const editSim = (data = {}) => {
  const {id = ""} = data;
  const url = getUrl("listSim");
  const patchUrl = `${url}${id}/`;
  return trackPromise(Call.patch(patchUrl, data));
};
export const simUsage = (id = "") => {
  const url = getUrl("simUsage")(id);
  return trackPromise(Call.patch(url));
};
